import React, { useContext, useState, useEffect } from "react";
import UploadBox from "../components/UploadBox";
import { supabase } from "../supabaseClient";
import { AuthContext } from "../AuthContext";
import { FaTrash, FaPen } from "react-icons/fa";
import ConfirmationModal from "../components/ConfirmationModal";
import AdditionalInfo from "../components/AdditionalInfo";

function EditExperienceForm({
  profileData,
  index,
  experience,
  onSave,
  onCancel,
  session,
}) {
  const [editedExperience, setEditedExperience] = useState(experience);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedExperience((prevExperience) => ({
      ...prevExperience,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const user_id = session.user.id; // Access user_id from session
    console.log("editedExperience variable = ", editedExperience);
    console.log("profileData variable = ", profileData);
    // Update the experiences object
    const updatedExperiences = {
      ...profileData, // Spread the existing profileData
      experiences: {
        ...profileData.experiences, // Spread the existing experiences
        work_experiences: profileData.experiences.work_experiences.map(
          (exp, idx) =>
            idx === index // Check if the current index matches the index of the experience being edited
              ? editedExperience // Replace the specific experience being edited
              : exp // Keep the existing experience
        ),
      },
    };

    // console.log("Updated profile info", updatedExperiences);
    const { data, error } = await supabase
      .from("resumeUploaded") // Replace with your actual table name
      .update({ experiences: updatedExperiences }) // Update the experiences column
      .eq("id", user_id);

    if (error) {
      console.error("Error updating experience:", error.message);
      // Optionally, show an error message to the user
    } else {
      onSave(updatedExperiences); // Update local state with the new experiences
      window.location.reload(); // Reload the page after saving
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div>
      <div className="mb-4">
        <label
          htmlFor="company"
          className="block text-gray-700 dark:text-gray-400"
        >
          Company
        </label>
        <input
          type="text"
          id="company"
          name="company"
          value={editedExperience.company}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="dates"
          className="block text-gray-700 dark:text-gray-400"
        >
          Dates
        </label>
        <input
          type="text"
          id="dates"
          name="dates"
          value={editedExperience.dates}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="responsibilities"
          className="block text-gray-700 dark:text-gray-400"
        >
          Responsibilities
        </label>
        <textarea
          id="responsibilities"
          name="responsibilities"
          value={editedExperience.responsibilities.join("\n")}
          onChange={(e) =>
            setEditedExperience((prevExperience) => ({
              ...prevExperience,
              responsibilities: e.target.value.split("\n"),
            }))
          }
          className="textarea textarea-bordered w-full"
          rows={4}
        />
      </div>
      <div className="flex justify-end">
        <button
          className="btn bg-purple-700 mr-2 text-blue-gray-50"
          onClick={handleSave}
        >
          Save
        </button>
        <button className="btn btn-outline" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}

function EditPersonalInfoForm({ experiences, onSave, onCancel, session }) {
  const [editedInfo, setEditedInfo] = useState(experiences.personal_info || {});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const user_id = session.user.id; // Access user_id from session

    // Update the entire experiences object
    const updatedExperiences = {
      ...experiences,
      personal_info: editedInfo, // Update only the personal_info part
    };

    console.log("Updated profile info", updatedExperiences);
    const { data, error } = await supabase
      .from("resumeUploaded") // Replace with your actual table name
      .update({ experiences: updatedExperiences }) // Update the experiences column
      .eq("id", user_id); // Assuming you have an 'id' field to identify the record

    if (error) {
      console.error("Error updating personal info:", error.message);
    } else {
      onSave(updatedExperiences); // Update local state with the new experiences
      window.location.reload(); // Reload the page after saving
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div>
      <div className="mb-4">
        <label
          htmlFor="name"
          className="block text-gray-700 dark:text-gray-400"
        >
          Name
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={editedInfo.name}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="phone"
          className="block text-gray-700 dark:text-gray-400"
        >
          Phone
        </label>
        <input
          type="text"
          id="phone"
          name="phone"
          value={editedInfo.phone}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="email"
          className="block text-gray-700 dark:text-gray-400"
        >
          Email
        </label>
        <input
          type="text"
          id="email"
          name="email"
          value={editedInfo.email}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="flex justify-end">
        <button
          className="btn bg-purple-700 mr-2 text-blue-gray-50"
          onClick={handleSave}
        >
          Save
        </button>
        <button className="btn btn-outline" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}

function EditProjectForm({
  profileData,
  index,
  project,
  onSave,
  onCancel,
  session,
}) {
  const [editedProject, setEditedProject] = useState(project);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedProject((prevProject) => ({
      ...prevProject,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const user_id = session.user.id; // Access user_id from session
    console.log("editedProject variable = ", editedProject);
    console.log("profileData variable = ", profileData);

    const updatedExperiences = {
      ...profileData, // Spread the existing profileData
      experiences: {
        ...profileData.experiences, // Spread the existing experiences
        projects: profileData.experiences.projects.map(
          (proj, idx) =>
            idx === index // Check if the current index matches the index of the project being edited
              ? editedProject // Replace the specific project being edited
              : proj // Keep the existing project
        ),
      },
    };

    console.log("Updated profile info", updatedExperiences);

    const { data, error } = await supabase
      .from("resumeUploaded") // Replace with your actual table name
      .update({ experiences: updatedExperiences }) // Update the experiences column
      .eq("id", user_id);
    if (error) {
      console.error("Error updating project:", error.message);
      // Optionally, show an error message to the user
    } else {
      onSave(updatedExperiences); // Update local state
      window.location.reload(); // Reload the page after saving
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div>
      <div className="mb-4">
        <label
          htmlFor="title"
          className="block text-gray-700 dark:text-gray-400"
        >
          Project Title
        </label>
        <input
          type="text"
          id="title"
          name="title"
          value={editedProject.title}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="responsibilities"
          className="block text-gray-700 dark:text-gray-400"
        >
          Responsibilities
        </label>
        <textarea
          id="responsibilities"
          name="responsibilities"
          value={editedProject.responsibilities.join("\n")}
          onChange={(e) =>
            setEditedProject((prevProject) => ({
              ...prevProject,
              responsibilities: e.target.value.split("\n"),
            }))
          }
          className="textarea textarea-bordered w-full"
          rows={4}
        />
      </div>
      <div className="flex justify-end">
        <button
          className="btn bg-purple-700 mr-2 text-blue-gray-50"
          onClick={handleSave}
        >
          Save
        </button>
        <button className="btn btn-outline" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}

const EducationForm = ({
  profileData,
  index,
  education,
  onSave,
  onCancel,
  session,
}) => {
  const [editedEducation, setEditedEducation] = useState(education);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedEducation((prevEducation) => ({
      ...prevEducation,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const user_id = session.user.id; // Access user_id from session
    console.log("editedEducation variable = ", editedEducation);
    console.log("profileData variable = ", profileData);
    // Update the education object
    const updatedExperiences = {
      ...profileData, // Spread the existing profileData
      education: profileData.education.map(
        (edu, idx) =>
          idx === index // Check if the current index matches the index of the education being edited
            ? editedEducation // Replace the specific education entry being edited
            : edu // Keep the existing education entry
      ),
    };
    console.log("Updated profile info", updatedExperiences);

    const { data, error } = await supabase
      .from("resumeUploaded") // Replace with your actual table name
      .update({ experiences: updatedExperiences }) // Update the experiences column
      .eq("id", user_id);

    if (error) {
      console.error("Error updating education:", error.message);
      // Optionally, show an error message to the user
    } else {
      onSave(updatedExperiences); // Update local state
    }
  };

  return (
    <div>
      <div className="mb-4">
        <label
          htmlFor="degree"
          className="block text-gray-700 dark:text-gray-400"
        >
          Degree
        </label>
        <input
          type="text"
          id="degree"
          name="degree"
          value={editedEducation.degree}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="institution"
          className="block text-gray-700 dark:text-gray-400"
        >
          Institution
        </label>
        <input
          type="text"
          id="institution"
          name="institution"
          value={editedEducation.institution}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="dates"
          className="block text-gray-700 dark:text-gray-400"
        >
          Dates
        </label>
        <input
          type="text"
          id="dates"
          name="dates"
          value={editedEducation.dates}
          onChange={handleInputChange}
          className="input input-bordered w-full"
        />
      </div>
      <div className="flex justify-end">
        <button
          className="btn bg-purple-700 mr-2 text-blue-gray-50"
          onClick={handleSave}
        >
          Save
        </button>
        <button className="btn btn-outline" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

function Profile() {
  const [educationData, setEducationData] = useState([]);
  const [experienceExists, setExperienceExists] = useState(false);
  const [experienceData, setExperienceData] = useState({
    work_experiences: [],
    projects: [],
  });
  const [editingExperience, setEditingExperience] = useState(null);
  const [editingPersonalInfo, setEditingPersonalInfo] = useState(false);
  const { session, userId } = useContext(AuthContext);
  const [personalInfo, setPersonalInfo] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [education, setEducation] = useState([]);
  const [isEditingEducationIndex, setIsEditingEducationIndex] = useState(null);
  const [educationToDelete, setEducationToDelete] = useState(null);
  const [isDeletingPersonalInfo, setIsDeletingPersonalInfo] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [itemType, setItemType] = useState("");
  const [profileData, setProfileData] = useState({});

  const handleStartEditExperience = (experience) => {
    setEditingExperience(experience);
  };

  const handleSaveWorkChanges = (updatedExperience) => {
    console.log(updatedExperience);
    setExperienceData(updatedExperience.experiences);
    setEditingExperience(null);
  };

  const handleCancelEditExperience = () => {
    setEditingExperience(null);
  };

  const handleStartEditPersonalInfo = () => {
    setEditingPersonalInfo(true);
  };

  const handleSavePersonalInfo = (updatedInfo) => {
    setPersonalInfo(updatedInfo);
    setEditingPersonalInfo(false);
  };

  const handleCancelEditPersonalInfo = () => {
    setEditingPersonalInfo(false);
  };

  const handleStartEditProject = (project) => {
    setEditingExperience(project); // Reusing editingExperience state for projects
  };

  const handleSaveProjectChanges = (updatedExperience) => {
    setExperienceData(updatedExperience.experiences);
    setEditingExperience(null);
  };

  const confirmDeletePersonalInfo = () => {
    setPersonalInfo({
      name: "",
      phone: "",
      email: "",
    });
    setIsModalOpen(false); // Close the modal after deletion
  };

  const confirmDeleteEducation = () => {
    if (educationToDelete !== null) {
      const updatedEducation = educationData.filter(
        (_, i) => i !== educationToDelete
      );
      setEducationData(updatedEducation);
      setEducationToDelete(null);
    }
    setIsModalOpen(false); // Close the modal
  };

  const handleSaveEducation = (updatedExperience) => {
    setEducationData(updatedExperience.education);
    setIsEditingEducationIndex(null);
  };

  // Function to open the confirmation modal for personal info
  const handleDeletePersonalInfo = () => {
    setIsModalOpen(true); // Open the confirmation modal
    setIsDeletingPersonalInfo(true); // Set context for personal info deletion
  };

  // Function to open the confirmation modal for education
  const openConfirmationModal = (index, type) => {
    setItemToDelete(index); // Set the index of the item to delete
    setItemType(type); // Set the type of item (work_experience or project)
    setIsModalOpen(true); // Open the modal
  };

  // Handle deletion logic
  const handleDelete = () => {
    if (itemType === "personal_info") {
      setPersonalInfo({
        name: "",
        phone: "",
        email: "",
      });
    } else if (itemType === "education") {
      const updatedEducation = educationData.filter(
        (_, i) => i !== itemToDelete
      );
      setEducationData(updatedEducation);
    } else if (itemType === "work_experience") {
      const updatedExperiences = experienceData.work_experiences.filter(
        (_, i) => i !== itemToDelete
      );
      setExperienceData((prevData) => ({
        ...prevData,
        work_experiences: updatedExperiences,
      }));
    } else if (itemType === "project") {
      const updatedProjects = experienceData.projects.filter(
        (_, i) => i !== itemToDelete
      );
      setExperienceData((prevData) => ({
        ...prevData,
        projects: updatedProjects,
      }));
    }
    setIsModalOpen(false); // Close the modal
  };

  useEffect(() => {
    const checkExperienceExists = async () => {
      const user_id = session.user.id;
      if (user_id) {
        const { data, error } = await supabase
          .from("resumeUploaded")
          .select("*")
          .eq("id", user_id);

        if (error) {
          console.error("Error fetching user data:", error.message);
        } else {
          setExperienceExists(data && data.length > 0);
          if (data.length > 0) {
            console.log("Data exists");
            console.log(data[0].experiences);
            setProfileData(data[0].experiences);
            setExperienceData(data[0].experiences.experiences); // Set all experiences including projects
            setPersonalInfo(data[0].experiences.personal_info || {});
            setEducationData(data[0].experiences.experiences.education || []); // Set education data
          }
        }
      }
    };

    checkExperienceExists(); // Call the function when component mounts
  }, [session]);

  return (
    <div className="bg-gray-50 px-4 sm:px-6 lg:px-8">
      {experienceExists && (
        <>
          {/* Personal Information Section */}
          <div className="h-14"></div>
          <div className="card bg-base-100 shadow-lg rounded-lg overflow-hidden mb-6">
            <div className="card-body text-left">
              <div className="">
                <h2 className="card-title dark:text-white">
                  Personal Information
                </h2>
                <hr className="border-gray-200 border dark:border-gray-600 my-2" />
                {editingPersonalInfo ? (
                  <EditPersonalInfoForm
                    experiences={profileData}
                    onSave={handleSavePersonalInfo}
                    onCancel={handleCancelEditPersonalInfo}
                    session={session}
                  />
                ) : (
                  <div className="">
                    <div className="flex items-center">
                      <p className="mr-2">Name: {personalInfo.name}</p>
                      <div
                        className="cursor-pointer"
                        onClick={handleStartEditPersonalInfo}
                      >
                        <FaPen className="w-4 h-4 text-purple-700" />
                      </div>
                      <div
                        className="cursor-pointer ml-2"
                        onClick={() =>
                          openConfirmationModal(null, "personal_info")
                        }
                      >
                        <FaTrash className="w-4 h-4 text-purple-700" />
                      </div>
                    </div>
                    <p>Phone: {personalInfo.phone}</p>
                    <p>Email: {personalInfo.email}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Education Section */}
          <div className="card bg-base-100 shadow-lg rounded-lg overflow-hidden mb-6">
            <div className="card-body text-left">
              <h2 className="card-title dark:text-white">Education</h2>
              <hr className="border-gray-200 border dark:border-gray-600 my-2" />

              {educationData.map((edu, index) => (
                <div key={index}>
                  {isEditingEducationIndex === index ? (
                    <EducationForm
                      profileData={profileData}
                      index={index}
                      education={edu}
                      onSave={handleSaveEducation}
                      onCancel={() => setIsEditingEducationIndex(null)}
                      session={session}
                    />
                  ) : (
                    <>
                      <div className="flex justify-between">
                        <h3 className="text-lg font-semibold">{edu.degree}</h3>
                        <div className="flex items-center">
                          <FaPen
                            className="cursor-pointer text-purple-700 mr-2"
                            onClick={() => setIsEditingEducationIndex(index)} // Set the index for editing
                          />
                          <FaTrash
                            className="cursor-pointer text-purple-700"
                            onClick={() =>
                              openConfirmationModal(index, "education")
                            } // Open confirmation modal for education
                          />
                        </div>
                      </div>
                      <p>{edu.institution}</p>
                      <p>{edu.dates}</p>
                      <ul className="list-disc pl-5">
                        {edu.details.map((detail, detailIndex) => (
                          <li key={detailIndex}>{detail}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleDelete} // Call the handleDelete function
        message={`Are you sure you want to delete this ${
          itemType === "personal_info"
            ? "personal information"
            : itemType === "education"
            ? "education entry"
            : itemType === "work_experience"
            ? "work experience"
            : itemType === "project"
            ? "project"
            : ""
        }?`}
      />

      {/* Work Experience Section */}

      {experienceExists ? (
        <div className="card mt-5 bg-base-100 dark:bg-gray-800 shadow-lg rounded-lg overflow-hidden mb-6">
          <div className="card-body text-left">
            <div>
              <h2 className="card-title dark:text-white">Work Experience</h2>
              <hr className="border-gray-200 border dark:border-gray-600 my-2" />
            </div>
            {experienceData.work_experiences.map((experience, index) => (
              <div key={index}>
                {editingExperience === experience ? (
                  <EditExperienceForm
                    profileData={profileData}
                    index={index}
                    experience={experience}
                    onSave={handleSaveWorkChanges}
                    onCancel={handleCancelEditExperience}
                    session={session}
                  />
                ) : (
                  <div>
                    <div className="flex justify-between items-center">
                      <p className="text-gray-900 text-xl font-serif font-semibold dark:text-gray-400">
                        {experience.company}
                      </p>
                      <div className="flex items-center">
                        <FaPen
                          className="text-purple-700 cursor-pointer"
                          onClick={() => handleStartEditExperience(experience)}
                        />
                        <FaTrash
                          className="cursor-pointer text-purple-700 ml-2"
                          onClick={() =>
                            openConfirmationModal(index, "work_experience")
                          }
                        />
                      </div>
                    </div>
                    <p className="text-gray-800 dark:text-gray-400 text-sm">
                      {experience.dates}
                    </p>
                    <ul className="mt-2 space-y-2">
                      {experience.responsibilities.map(
                        (responsibility, index) => (
                          <li
                            key={index}
                            className="text-gray-800 dark:text-gray-400 text-sm flex items-center space-x-2"
                          >
                            <span className="text-gray-500 dark:text-gray-400">
                              •
                            </span>
                            <span>{responsibility}</span>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div>
          <UploadBox />
        </div>
      )}

      {/* Projects Section */}
      {experienceExists &&
        experienceData.projects &&
        experienceData.projects.length > 0 && (
          <div className="card mt-5 bg-base-100 dark:bg-gray-800 shadow-lg rounded-lg overflow-hidden mb-6">
            <div className="card-body text-left">
              <div>
                <h2 className="card-title dark:text-white">Projects</h2>
                <hr className="border-gray-200 border dark:border-gray-600 my-2" />
              </div>
              {experienceData.projects.map((project, index) => (
                <div key={index} className="mb-4">
                  {editingExperience === project ? (
                    <EditProjectForm
                      profileData={profileData}
                      index={index}
                      project={project}
                      onSave={handleSaveProjectChanges}
                      onCancel={handleCancelEditExperience}
                      session={session}
                    />
                  ) : (
                    <>
                      <div className="flex justify-between">
                        <h3 className="text-lg font-semibold">
                          {project.title}
                        </h3>
                        <div className="flex items-center">
                          <FaPen
                            className="text-purple-700 cursor-pointer"
                            onClick={() => handleStartEditProject(project)}
                          />
                          <FaTrash
                            className="cursor-pointer text-purple-700 ml-2"
                            onClick={() =>
                              openConfirmationModal(index, "project")
                            }
                          />
                        </div>
                      </div>
                      <ul className="">
                        {project.responsibilities.map(
                          (responsibility, index) => (
                            <li
                              key={index}
                              className="text-gray-800 dark:text-gray-400 text-sm flex items-center space-x-2"
                            >
                              <span className="text-gray-500 dark:text-gray-400">
                                •
                              </span>
                              <span>{responsibility}</span>
                            </li>
                          )
                        )}
                      </ul>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      {experienceExists && (
        <>
          {/* Additional Information Section moved after Projects */}
          <AdditionalInfo
            profileData={profileData}
            session={session}
            onSave={(updatedInfo) => {
              setProfileData((prevData) => ({
                ...prevData,
                additional_information: updatedInfo,
              }));
            }}
          />
        </>
      )}
    </div>
  );
}

export default Profile;
